<template>
  <a-modal :maskClosable="false" :visible="value" title="关联呼叫类型" :width="600" @cancel="onClose">
    <a-form-model :model="form" :rules="rules" ref="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="关联呼叫类型" prop="andonTypeId">
          <a-select v-model="form.andonTypeId" 
          :placeholder="$t('please_select')"
          show-search
          optionFilterProp="children"
          allowClear
          >
            <a-select-option :value="item.id" v-for="(item,index) in typeList" :key="index">
              {{item.codeAndName}}
            </a-select-option>
          </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注">
        <a-textarea
          :placeholder="$t('common_please_input')"
          :auto-size="{ minRows: 2, maxRows: 6 }"
          v-model="form.remark"
        />
      </a-form-model-item>
    </a-form-model>
    <div slot="footer">
       <a-button @click="onClose" type="default">
        取消
      </a-button>
      <a-button @click="onReset" type="danger">
        重置
      </a-button>
       <a-button @click="onSubmit" type="primary">
        保存
      </a-button>
     </div>
  </a-modal>
</template>

<script>
import { AndonTypeServiceProxy } from '@/service-proxies/app-v2/andon.service-proxies'
import { DeviceTypeAndonTypeServiceProxy} from '@/service-proxies/app-v2/tpm.service-proxies'
const deviceTypeAndonTypeServiceProxy = new DeviceTypeAndonTypeServiceProxy();
const andonTypeServiceProxy = new AndonTypeServiceProxy();
// getCodeAndName
export default {
  props:{
    value:{
      type:Boolean,
      default:false
    },
    deviceTypeId:{
    }
  },
  watch:{
    value:function(newVal,oldVal){
      if(!newVal){
        this.$refs.form.resetFields();
        this.form = {}
      }else{
        this.getTypeList()
      }
    }
  },
  methods:{
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.indexOf(input.toUpperCase()) >= 0
      );
    },
    getTypeList(){
      andonTypeServiceProxy.getCodeAndName().then(res => {
        this.typeList = res || []
      })
    },
    onClose(){
      this.$emit('close',false);
    },
    selectType(){

    },
    // 重置
    onReset(){
      this.$refs.form.resetFields();
    },
    // 保存
    onSubmit(){
      this.$refs.form.validate(valid => {
        if (valid) {
          let seletAndonType = this.typeList.find(item => item.id == this.form.andonTypeId);
          let data = {
            deviceTypeId:this.deviceTypeId,
            andonTypeId:this.form.andonTypeId,
            remark:this.form.remark
          }
          if(seletAndonType){
            let codeAndNameArr = seletAndonType.codeAndName.split('-');
            data.andonTypeCode = codeAndNameArr[0];
            data.andonTypeName = codeAndNameArr[1];
          }
          deviceTypeAndonTypeServiceProxy.createDeviceTypeAndonType(data).then(res => {
            this.$message.success('关联呼叫类型成功');
            this.$emit('ok')
          })
        } else {
          
        }
      });
    }
  },
  data(){
    return {
      labelCol: {span: 6},
      wrapperCol: {span: 16},
      form:{},
      typeList:[],
      rules:{
        andonTypeId: [
          { required: true, message: '请选择', trigger: 'change' },
        ]
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>